/* -------------------------------------------------------------------------------------------------
   <auto-generated>
      This code was generated from a T4 template.

      DO NOT ALTER!
      Changes to this file may cause incorrect behavior and will be lost if the code is regenerated.

      Template Authors: Leonard Lewis
   </auto-generated>
   ------------------------------------------------------------------------------------------------- */

/// <summary>
///   Core.EducationLevel_
///   This is an auto-generated enumeration of the SWFC_Learning.Core.EducationLevel domain table...
/// </summary>
import { IDomainModel } from './domain-model.interface';

export enum EducationLevel_ {
   /// <summary>
   ///   Baby (Baby)
   /// </summary>
   Baby = -6,
   /// <summary>
   ///   Preschool (age 1) (Pre(1))
   /// </summary>
   PreschoolAge1 = -5,
   /// <summary>
   ///   Preschool (age 2) (Pre(2))
   /// </summary>
   PreschoolAge2 = -4,
   /// <summary>
   ///   Preschool (age 3) (Pre(3))
   /// </summary>
   PreschoolAge3 = -3,
   /// <summary>
   ///   Pre-K (age 4) (Pre-K(4))
   /// </summary>
   PreKAge4 = -2,
   /// <summary>
   ///   Kindergarten (K)
   /// </summary>
   Kindergarten = -1,
   /// <summary>
   ///   Not Specified ( )
   /// </summary>
   NotSpecified = 0,
   /// <summary>
   ///   1st Grade (1st)
   /// </summary>
   One = 1,
   /// <summary>
   ///   2nd Grade (2nd)
   /// </summary>
   Two = 2,
   /// <summary>
   ///   3rd Grade (3rd)
   /// </summary>
   Three = 3,
   /// <summary>
   ///   4th Grade (4th)
   /// </summary>
   Four = 4,
   /// <summary>
   ///   5th Grade (5th)
   /// </summary>
   Five = 5,
   /// <summary>
   ///   6th Grade (6th)
   /// </summary>
   Six = 6,
   /// <summary>
   ///   7th Grade (7th)
   /// </summary>
   Seven = 7,
   /// <summary>
   ///   8th Grade (8th)
   /// </summary>
   Eight = 8,
   /// <summary>
   ///   9th Grade (9th)
   /// </summary>
   Nine = 9,
   /// <summary>
   ///   10th Grade (10th)
   /// </summary>
   Ten = 10,
   /// <summary>
   ///   11th Grade (11th)
   /// </summary>
   Eleven = 11,
   /// <summary>
   ///   12th Grade (12th)
   /// </summary>
   Twelve = 12,
   /// <summary>
   ///   University Freshman (Freshman)
   /// </summary>
   UnivFresh = 13,
   /// <summary>
   ///   University Sophomore (Soph)
   /// </summary>
   UnivSoph = 14,
   /// <summary>
   ///   University Junior (Junior)
   /// </summary>
   UnivJunior = 15,
   /// <summary>
   ///   University Senior (Senior)
   /// </summary>
   UnivSenior = 16,
   /// <summary>
   ///   Graduate Student (Grad Stu)
   /// </summary>
   GradStudent = 17,
   /// <summary>
   ///   Professional (Prof)
   /// </summary>
   Professional = 18
}

export const EducationLevels: EducationLevel[] = [
   {
      code: EducationLevel_.Baby,
      literal: 'Baby',
      description: 'Baby',
      shortDescription: 'Baby',
      listPriority: 1,

      curriculumLevelCode: 1,

      age: 0,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.PreschoolAge1,
      literal: 'PreschoolAge1',
      description: 'Preschool (age 1)',
      shortDescription: 'Pre(1)',
      listPriority: 2,

      curriculumLevelCode: 1,

      age: 1,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.PreschoolAge2,
      literal: 'PreschoolAge2',
      description: 'Preschool (age 2)',
      shortDescription: 'Pre(2)',
      listPriority: 3,

      curriculumLevelCode: 1,

      age: 2,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.PreschoolAge3,
      literal: 'PreschoolAge3',
      description: 'Preschool (age 3)',
      shortDescription: 'Pre(3)',
      listPriority: 4,

      curriculumLevelCode: 2,

      age: 3,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.PreKAge4,
      literal: 'PreKAge4',
      description: 'Pre-K (age 4)',
      shortDescription: 'Pre-K(4)',
      listPriority: 5,

      curriculumLevelCode: 2,

      age: 4,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.Kindergarten,
      literal: 'Kindergarten',
      description: 'Kindergarten',
      shortDescription: 'K',
      listPriority: 6,

      curriculumLevelCode: 3,

      age: 5,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.NotSpecified,
      literal: 'NotSpecified',
      description: 'Not Specified',
      shortDescription: ' ',
      listPriority: 0,

      curriculumLevelCode: 0,

      age: -1,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.One,
      literal: 'One',
      description: '1st Grade',
      shortDescription: '1st',
      listPriority: 7,

      curriculumLevelCode: 4,

      age: 6,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.Two,
      literal: 'Two',
      description: '2nd Grade',
      shortDescription: '2nd',
      listPriority: 8,

      curriculumLevelCode: 5,

      age: 7,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.Three,
      literal: 'Three',
      description: '3rd Grade',
      shortDescription: '3rd',
      listPriority: 9,

      curriculumLevelCode: 6,

      age: 8,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.Four,
      literal: 'Four',
      description: '4th Grade',
      shortDescription: '4th',
      listPriority: 10,

      curriculumLevelCode: 7,

      age: 9,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.Five,
      literal: 'Five',
      description: '5th Grade',
      shortDescription: '5th',
      listPriority: 11,

      curriculumLevelCode: 8,

      age: 10,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.Six,
      literal: 'Six',
      description: '6th Grade',
      shortDescription: '6th',
      listPriority: 12,

      curriculumLevelCode: 9,

      age: 11,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.Seven,
      literal: 'Seven',
      description: '7th Grade',
      shortDescription: '7th',
      listPriority: 13,

      curriculumLevelCode: 0,

      age: 12,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.Eight,
      literal: 'Eight',
      description: '8th Grade',
      shortDescription: '8th',
      listPriority: 14,

      curriculumLevelCode: 0,

      age: 13,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.Nine,
      literal: 'Nine',
      description: '9th Grade',
      shortDescription: '9th',
      listPriority: 15,

      curriculumLevelCode: 0,

      age: 14,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.Ten,
      literal: 'Ten',
      description: '10th Grade',
      shortDescription: '10th',
      listPriority: 16,

      curriculumLevelCode: 0,

      age: 15,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.Eleven,
      literal: 'Eleven',
      description: '11th Grade',
      shortDescription: '11th',
      listPriority: 17,

      curriculumLevelCode: 0,

      age: 16,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.Twelve,
      literal: 'Twelve',
      description: '12th Grade',
      shortDescription: '12th',
      listPriority: 18,

      curriculumLevelCode: 0,

      age: 17,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.UnivFresh,
      literal: 'UnivFresh',
      description: 'University Freshman',
      shortDescription: 'Freshman',
      listPriority: 19,

      curriculumLevelCode: 0,

      age: 18,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.UnivSoph,
      literal: 'UnivSoph',
      description: 'University Sophomore',
      shortDescription: 'Soph',
      listPriority: 20,

      curriculumLevelCode: 0,

      age: 19,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.UnivJunior,
      literal: 'UnivJunior',
      description: 'University Junior',
      shortDescription: 'Junior',
      listPriority: 21,

      curriculumLevelCode: 0,

      age: 20,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.UnivSenior,
      literal: 'UnivSenior',
      description: 'University Senior',
      shortDescription: 'Senior',
      listPriority: 22,

      curriculumLevelCode: 0,

      age: 21,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.GradStudent,
      literal: 'GradStudent',
      description: 'Graduate Student',
      shortDescription: 'Grad Stu',
      listPriority: 23,

      curriculumLevelCode: 0,

      age: 22,

      typeName: "EducationLevel"
   },
   {
      code: EducationLevel_.Professional,
      literal: 'Professional',
      description: 'Professional',
      shortDescription: 'Prof',
      listPriority: 24,

      curriculumLevelCode: 0,

      age: 23,

      typeName: "EducationLevel"
   }
]

export class EducationLevel implements IDomainModel {
   code: EducationLevel_
   literal: string
   description: string
   shortDescription: string
   listPriority: number

   curriculumLevelCode: number

   age: number

   typeName: string

   static toDomainModel(code: EducationLevel_): EducationLevel {
      return EducationLevels.find(d => d.code === code)
   }
}
